import {adminRoles, UserRoleEnum} from "@/enums/userRolesEnum";
import BillablePayablesReport from "@/components/reports/billablepayable/BillablePayablesReport";
import PresidentsGoalReport from "@/components/reports/presidentsgoal/PresidentsGoalReport";
import ProviderWorkSummaryReport from "@/components/reports/providerworksummary/ProviderWorkSummaryReport";
import RepresentativeGoalReport from "@/components/reports/representativegoal/RepresentativeGoalReport";
import MonthlyBonusReport from "@/components/reports/monthlybonus/MonthlyBonusReport";
import ProviderReport from "@/components/reports/providers/ProviderReport";
import FacilityOverviewReport from "@/components/reports/facilityoverview/FacilityOverviewReport";

export interface ReportRegister {
  path: string,  // should be both the front end path and the api path
  name: string,  // for convenience, match the name of the file/component
  component: any, // the component on the router
  roles: UserRoleEnum[], // authorized roles to run the report
  description: string // used by the selector on ./Reports.vue
}

// add the roles that can access the report here along with component information for internal routing
export const reportRegisters = [
  {
    path: 'billable-payables',
    name: 'BillablePayablesReport',
    component: BillablePayablesReport,
    roles: [
      UserRoleEnum.MANAGER,
      UserRoleEnum.ACCOUNTANT
    ],
    description: 'Billable And Payables'
  },
  {
    path: 'presidents-goals',
    name: 'PresidentsGoalReport',
    component: PresidentsGoalReport,
    roles: adminRoles,
    description: "President's Goal"
  },
  {
    path: 'provider-work-summaries',
    name: 'ProviderWorkSummaryReport',
    component: ProviderWorkSummaryReport,
    roles: adminRoles,
    description: 'Provider Work Summary'
  },
  {
    path: 'representative-goals',
    name: 'RepresentativeGoalReport',
    component: RepresentativeGoalReport,
    roles: adminRoles,
    description: 'Representative Goal'
  },
  {
    path: 'facility-overviews',
    name: 'FacilityOverviewReport',
    component: FacilityOverviewReport,
    roles: adminRoles,
    description: 'Facility Overview'
  },
  {
    path: 'monthly-bonuses',
    name: 'MonthlyBonusReport',
    component: MonthlyBonusReport,
    roles: adminRoles,
    description: 'Monthly Bonus'
  },
  {
    path: 'providers',
    name: 'ProvidersReport',
    component: ProviderReport,
    roles: adminRoles,
    description: 'Providers'
  }
] as ReportRegister[];

const roleMap = new Map<string, ReportRegister>(reportRegisters.map(register => [register.name, register]) as [string, any]);
export function getReportByName(reportName: string) : ReportRegister {
  return roleMap.get(reportName)!;  // null fail fast if someone passes in a bad report name
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/reports/reportRegistry.ts